<template>
  <div class="chart-box container">
    <el-row :gutter="20">
      <el-col :span="5" class="results-left">
        <el-card class="box-card department-card" style="margin-top: 0">
          <div slot="header" class="clearfix">
            <span>导航</span>
          </div>
          <el-menu default-active="2" class="el-menu-vertical-demo">
            <el-menu-item index="2">
              <span slot="title">1.SCI论文分析</span>
            </el-menu-item>
            <el-submenu index="1">
              <template slot="title">
                <span>2.结果分析</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="1-1">
                  <span @click="scrollInto('a01')">2.1本院部门分析</span>
                </el-menu-item>
                <el-menu-item index="1-2">
                  <span @click="scrollInto('a02')">2.2本院作者分析</span>
                </el-menu-item>
                <el-menu-item index="1-3">
                  <span @click="scrollInto('a03')">2.3学科分析</span>
                </el-menu-item>
                <el-menu-item index="1-4">
                  <span @click="scrollInto('a04')">2.4期刊分析</span>
                </el-menu-item>
                <el-menu-item index="1-5">
                  <span @click="scrollInto('a05')">2.5期刊影响因子分析</span>
                </el-menu-item>
                <el-menu-item index="1-6">
                  <span @click="scrollInto('a06')">2.6期刊分区分析</span>
                </el-menu-item>
                <el-menu-item index="1-7">
                  <span @click="scrollInto('a07')">2.7本院期刊分区分析</span>
                </el-menu-item>
                <el-menu-item index="1-8">
                  <span @click="scrollInto('a08')">2.8第一作者机构分析</span>
                </el-menu-item>
                <el-menu-item index="1-9">
                  <span @click="scrollInto('a09')">2.9论文关键字分析</span>
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>
            <el-menu-item index="3">
              <span slot="title">
                <a href="/api/analysisDiss/exportExcel">3.SCI文献导出</a>
              </span>
            </el-menu-item>
          </el-menu>
        </el-card>
      </el-col>
      <el-col :span="19">
        <el-card class="box-card result-card analysis-card">
          <div slot="header" class="clearfix">
            <span>
              <b>1.SCI论文分析</b>
            </span>
          </div>
          <div
            class="analysis-text"
          >本分析报告收录了{{analysis.hospitalName}}历年发表的sci论文，数据来源于PubMed收录（PubMed中收录的期刊也并非全是SCI期刊，PubMed收录的期刊范围与SCI有重复，包含但又不限于SCI期刊中的生物医学部分，本次以PubMed收录统计）。</div>
        </el-card>

        <el-card class="box-card result-card analysis-card">
          <div slot="header" class="clearfix">
            <span>
              <b>2.结果分析</b>
            </span>
          </div>
          <div
            class="analysis-text"
          >现对PubMed收录的{{analysis.hospitalName}}作者的{{analysis.foreginNum}}篇文献，进行分析。</div>

          <el-card class="box-card result-card analysis-card analysis-second-card" shadow="never">
            <div slot="header" class="clearfix">
              <span>
                <span id="a01">2.1本院部门分析</span>
              </span>
            </div>
            <div
              class="analysis-text"
            >结果详见统计图1。发文最多的科室是{{analysis.deptList.length != 0 ? analysis.deptList[0].deptName : ''}}，其次是{{analysis.deptList.length != 0 ? analysis.deptList[1].deptName : ''}}，前三名均是本院科研实力雄厚的部门，但排名和数据与实际科研产出情况可能略有偏差，原因与作者未署名部门或部门署名不规范、不统一有直接关系。</div>
            <div :id="id1" :option="options1" class="my-chart"></div>
          </el-card>

          <el-card class="box-card result-card analysis-card analysis-second-card" shadow="never">
            <div slot="header" class="clearfix">
              <span>
                <span id="a02">2.2 本院作者分析</span>
              </span>
            </div>
            <div
              class="analysis-text"
            >按所有作者发表论文的数量降序排列，结果详见统计图2。此分析包括但不限于第一作 者或通迅作者，是按所有作者出现的频次多寡排序，需结合作者对论文的贡献来评价其学术水平。</div>
            <div :id="id2" :option="options2" class="my-chart"></div>
          </el-card>

          <el-card class="box-card result-card analysis-card analysis-second-card" shadow="never">
            <div slot="header" class="clearfix">
              <span>
                <span id="a03">2.3 学科分析</span>
              </span>
            </div>
            <div class="analysis-text">
              结果详见统计图3。排名前列的依次为
              <a
                v-for="item in topSubject"
                :key="item.journalPartitionClassification"
              >{{item.journalPartitionClassification}},</a>与本院重点学科的科研实力基本相吻合，研究与实验排名靠前或与PubMed的学科分类体系有关。
            </div>
            <div :id="id3" :option="options3" class="my-chart"></div>
          </el-card>

          <el-card class="box-card result-card analysis-card analysis-second-card" shadow="never">
            <div slot="header" class="clearfix">
              <span>
                <span id="a04">2.4 期刊分析</span>
              </span>
            </div>
            <div
              class="analysis-text"
            >结果详见统计图4。{{topJournal[0].journalName}}刊载文献最多，共{{topJournal[0].count}}篇,占全部文献的{{journalPercent}}；其 次是{{topJournal[1].journalName}}和{{topJournal[2].journalName}}，分别刊发{{topJournal[1].count}}篇和 {{topJournal[2].count}}篇。对比PubMed和SCI收录本院论文的来源期刊，排名前十的期刊中有8种重 合，并且位次顺序基本相同，但同一种期刊的收录论文数量不同，因为两个系统的数据更新 时间不同，并且同一种期刊在两系统的更新并不完全同步。</div>
            <div :id="id4" :option="options4" class="my-chart"></div>
          </el-card>

          <el-card class="box-card result-card analysis-card analysis-second-card" shadow="never">
            <div slot="header" class="clearfix">
              <span>
                <span id="a05">2.5 期刊影响因子分析</span>
              </span>
            </div>
            <!-- <div class="analysis-text">
                结果详见图5。发现本院pubmed论文来源期刊影响因子多集中在值为1-7之间，占比 超过70%。发表于影响因子（Impact Factor,IF）20分以上期刊的文章共4篇， 其中 有三篇是本院消化科作为第一作者单位发表的文章，题目分别为“Rare multiple lesions arising in small and large intestines.”和“A Rare Cause of Gastrointestinal Bleeding in a Patient With aHistory of Alcoholic Cirrhosis.”的文章，发表在Gastroenterology上，IF值为20.773(2017年)；题 目为“A woman with intractable nausea andvomiting”的文章发表在BMJ上，IF值为23.259(2017年)。 另一篇是医院肿瘤化疗科合著的题目为“Effect of Anlotinib as a Third-Line or Further Treatment on OverallSurvival of Patients With Advanced Non-Small Cell Lung Cancer: The ALTER 0303Phase 3 Randomized Clinical Trial”的文章，发表在JAMA Oncol上， IF值为20.871(2017年）。
            </div>recentif.percent-->
            <div
              class="analysis-text"
            >结果详见图5。发现本院pubmed论文来源期刊影响因子多集中在值为1-7之间，占比 超过{{recentif.percent ? recentif.percent : ''}}%。其中影响因子处于{{recentif.records.length != 0 ? recentif.records[2].recentIF: ''}}的文章最多，共{{recentif.records.length != 0 ? recentif.records[2].count : ''}}篇。</div>
            <div :id="id5" :option="options5" class="my-chart"></div>
          </el-card>

          <el-card class="box-card result-card analysis-card analysis-second-card" shadow="never">
            <div slot="header" class="clearfix">
              <span>
                <span id="a06">2.6期刊分区分析</span>
              </span>
            </div>
            <div
              class="analysis-text"
            >根据JCR期刊分区方法进行分析，结果详见图6。《期刊引证报告》（Journal Citation Reports，JCR）将收录期刊分为176个不同学科类别，每个学科分类按照期刊的影响因子高低， 平均四等分为Q1、Q2、Q3和Q4四个区，即各学科分类中影响因子前25%(含25%)期刊划分为Q1区，依次类推。本院pubmed论文期刊分区的学科分类与SCI分析报告中的整体研究方向较为一致，这与来源期刊的研究侧重面相关， 论文的研究方向对应来源期刊的学科领域。同时，期刊分区则是以影响因子为据，仅以此指标侧面反映论文的质量和水平。</div>
            <div :id="id6" :option="options6" class="my-chart"></div>
          </el-card>

          <el-card class="box-card result-card analysis-card analysis-second-card" shadow="never">
            <div slot="header" class="clearfix">
              <span>
                <span id="a07">2.7本院期刊分区分析</span>
              </span>
            </div>
            <div
              class="analysis-text"
            >结果详见统计图7。本院期刊分区方法是对每年度的《期刊引证报告》中SCI期刊，先分学科，然后在学科内依据3年平均影响因子划分区， 以此来衡量期刊学术影响力。分析结果显示，排名前三的学科分别是{{zkypart[0]}}、{{zkypart[1]}}和{{zkypart[2]}}，与本院SCI论文的研 究方向排名前三位基本一致，说明这些领域是研究热点。</div>
            <div :id="id7" :option="options7" class="my-chart"></div>
          </el-card>

          <el-card class="box-card result-card analysis-card analysis-second-card" shadow="never">
            <div slot="header" class="clearfix">
              <span>
                <span id="a08">2.8第一作者机构分析</span>
              </span>
            </div>
            <div
              class="analysis-text"
            >结果详见统计图8。{{hos.name}}最多，共{{hos.count}}篇，占比{{hos.percent}}%，说明半数以上的文章由{{hos.name}}作者作为主要贡献者完成。</div>
            <div :id="id8" :option="options8" class="my-chart"></div>
          </el-card>

          <el-card class="box-card result-card analysis-card analysis-second-card" shadow="never">
            <div slot="header" class="clearfix">
              <span id="a09">
                <span id="t1">2.9论文关键字分析</span>
              </span>
            </div>
            <div class="analysis-text">结果详见统计图9，论文出现频率高的词汇。</div>
            <div :id="id9" :option="options9" class="my-chart"></div>
          </el-card>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import axios from 'axios'
import HighCharts from 'highcharts'
import wordcloud from 'highcharts/modules/wordcloud'
wordcloud(HighCharts)
require('highcharts/modules/exporting')(HighCharts)
export default {
  name: 'index',
  data() {
    return {
      topSubject: [],
      hos: {
        name: '',
        count: 0,
        percent: '',
      },
      recentif: {
        percent: '',
        records: [],
      },
      journalPercent: '',
      topJournal: [
        {
          journalName: '',
          count: 0,
          percent: 0,
        },
        {
          journalName: '',
          count: 0,
        },
        {
          journalName: '',
          count: 0,
        },
      ],
      zkypart: [],
      analysis: {
        deptList: [],
        beforeList: [
          {
            deptName: '',
          },
          {
            deptName: '',
          },
        ],
        hospitalName: '',
        foreginNum: 0,
      },
      activeName: 'second',
      titleStyle: { color: '#67C23A', fontSize: '14px' },
      colordata: [
        '#F6BD0F',
        '#AFD8F8',
        '#8BBA00',
        '#FF8E46',
        '#8E468E',
        '#008E8E',
        '#D64646',
        '#AFD8F8',
        '#AD8F26',
        '#DD88FF',
      ],
      lang: {
        contextButtonTitle: '图表导出菜单',
        decimalPoint: '.',
        downloadJPEG: '下载JPEG图片',
        downloadPDF: '下载PDF文件',
        downloadPNG: '下载PNG文件',
        downloadSVG: '下载SVG文件',
        drillUpText: '返回 {series.name}',
        loading: '加载中',
        months: [
          '一月',
          '二月',
          '三月',
          '四月',
          '五月',
          '六月',
          '七月',
          '八月',
          '九月',
          '十月',
          '十一月',
          '十二月',
        ],
        noData: '没有数据',
        numericSymbols: ['千', '兆', 'G', 'T', 'P', 'E'],
        printChart: '打印图表',
        resetZoom: '恢复缩放',
        resetZoomTitle: '恢复图表',
        shortMonths: [
          'Jan',
          'Feb',
          'Mar',
          'Apr',
          'May',
          'Jun',
          'Jul',
          'Aug',
          'Sep',
          'Oct',
          'Nov',
          'Dec',
        ],
        thousandsSep: ',',
        weekdays: [
          '星期一',
          '星期二',
          '星期三',
          '星期四',
          '星期五',
          '星期六',
          '星期天',
        ],
      },
      xdata1: ['骨科分部', '本院（集团）领导'],
      ydata1: [
        { color: '#F6BD0F', y: 181 },
        { color: '#AFD8F8', y: 81 },
      ],
      options1: {},
      id1: 'chart1',
      data2: [
        { name: '朱敏', data: [46] },
        { name: '林爱芬', data: [40] },
      ],
      options2: {},
      id2: 'chart2',
      data3: [
        ['ONCOLOGY', 34],
        ['SURGERY', 34],
      ],
      options3: {},
      id3: 'chart3',
      xdata4: ['Zhongguo gu shang =…', 'Zhonghua yi xue za zhi.'],
      ydata4: [
        { color: '#F6BD0F', y: 181 },
        { color: '#AFD8F8', y: 81 },
      ],
      options4: {},
      id4: 'chart4',
      xdata5: [],
      ydata5: [],
      options5: {},
      id5: 'chart5',
      data6: [
        ['Q1', 34],
        ['Q2', 34],
      ],
      options6: {},
      id6: 'chart6',
      data7: [
        { name: '医学:4区', data: [46] },
        { name: '医学:3区', data: [40] },
      ],
      options7: {},
      id7: 'chart7',
      xdata8: ['nnn'],
      ydata8: [20],
      options8: {},
      id8: 'chart8',
      data9: [
        { name: 'Lorem', weight: 1 },
        { name: 'sit', weight: 2 },
      ],
      options9: {},
      id9: 'chart9',
    }
  },
  created() {
    this.getAnalysis()
  },
  methods: {
    scrollInto(href) {
      document.getElementById(href).scrollIntoView()
    },
    getAnalysis() {
      let currThis = this
      axios({
        method: 'get',
        url: '/api/analysis',
      })
        .then(function (response) {
          currThis.analysis = response.data.data
        })
        .catch(function (thrown) {})
    },
    getData(index) {
      let currThis = this
      axios({
        method: 'get',
        url: '/api/analysis/' + index,
      })
        .then(function (response) {
          var data = response.data.data
          if (index === 1) {
            //2.1科室分析
            axios({
              method: 'get',
              url: '/api/analysis',
            })
              .then(function (response) {
                let list = response.data.data.deptList
                var xdata = []
                var ydata = []
                for (var i = 0; i < list.length; i++) {
                  xdata.push(list[i].deptName)
                  ydata.push({ color: currThis.colordata[i], y: list[i].count })
                }
                let options1 = {
                  chart: {
                    //renderTo: 'myChart1',
                    type: 'column',
                    options3d: {
                      enabled: true,
                      alpha: 10,
                      beta: 5,
                      depth: 100,
                    },
                  },
                  tooltip: {
                    // head + 每个 point + footer 拼接成完整的 table
                    headerFormat: '<table>',
                    pointFormat:
                      '<tr>' +
                      '<td style="padding:0"><b>{point.y}篇 </b></td></tr>',
                    footerFormat: '</table>',
                    shared: true,
                    useHTML: true,
                  },
                  xAxis: {
                    type: 'category',
                    categories: xdata,
                    labels: {
                      format: '{value}',
                      rotation: -40, //倾斜的角度
                    },
                  },
                  yAxis: {
                    title: {
                      enabled: false,
                    },
                    allowDecimals: false,
                  },
                  title: {
                    text: '统计图1：本院历年以来PubMed论文科室Top10',
                    style: currThis.titleStyle,
                  },
                  plotOptions: {
                    column: {
                      depth: 25,
                    },
                  },
                  legend: {
                    enabled: false,
                    backgroundColor: '#FFFFFF',
                    shadow: true,
                  },
                  series: [
                    {
                      //name:'图例1',
                      data: ydata,
                    },
                  ],
                  lang: currThis.lang,
                  credits: {
                    enabled: false,
                  },
                }
                currThis.options1 = options1
                HighCharts.chart(currThis.id1, currThis.options1)
              })
              .catch(function (thrown) {})
          } else if (index === 2) {
            var newdata = []
            data.resultList.forEach(function (item) {
              newdata.push({ name: item.userName, data: [item.count] })
            })
            let options2 = {
              chart: {
                type: 'bar',
              },
              title: {
                text: '统计图2：本院PubMed论文作者Top10',
                style: currThis.titleStyle,
              },
              xAxis: {
                categories: [''],
                title: {
                  text: null,
                },
                minTickInterval: 1,
              },
              yAxis: {
                min: 0,
                title: {
                  text: '论文数量 (篇)',
                  align: 'high',
                },
                allowDecimals: false,
              },
              tooltip: {
                valueSuffix: '篇',
              },
              plotOptions: {
                bar: {
                  dataLabels: {
                    enabled: true,
                    allowOverlap: true, // 允许数据标签重叠
                  },
                },
              },
              legend: {
                layout: 'vertical',
                align: 'right',
                verticalAlign: 'top',
                x: -10,
                y: 100,
                floating: true,
                borderWidth: 1,
                //backgroundColor: ((Highcharts.theme && Highcharts.theme.legendBackgroundColor) || '#FFFFFF'),
                shadow: true,
              },
              series: newdata,
              lang: currThis.lang,
              credits: {
                enabled: false,
              },
            }
            currThis.options2 = options2
            HighCharts.chart(currThis.id2, currThis.options2)
          } else if (index === 3) {
            var newdata = []
            data.resultList.forEach(function (item) {
              newdata.push([
                item.journalPartitionClassification,
                Number(item.ratio),
              ])
            })
            let options3 = {
              chart: {
                type: 'pie',
                options3d: {
                  enabled: true,
                  alpha: 45,
                  beta: 0,
                },
              },
              title: {
                text: '统计图3：本院PubMed论文学科Top10',
                style: currThis.titleStyle,
              },
              tooltip: {
                pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>',
              },
              plotOptions: {
                pie: {
                  allowPointSelect: true,
                  cursor: 'pointer',
                  depth: 35,
                  dataLabels: {
                    enabled: true,
                    format: '{point.name}',
                  },
                },
              },
              series: [
                {
                  type: 'pie',
                  name: '占比',
                  data: newdata,
                },
              ],
              lang: currThis.lang,
              credits: {
                enabled: false,
              },
            }
            currThis.options3 = options3
            HighCharts.chart(currThis.id3, currThis.options3)
            currThis.topSubject = data.resultList.slice(0, 3)
          } else if (index === 4) {
            //3.4期刊分析
            currThis.journalPercent = data.journalPercent
            data = data.resultList
            currThis.topJournal = data
            var xdata = []
            var ydata = []
            for (var i = 0; i < data.length; i++) {
              xdata.push(data[i].journalName)
              ydata.push({ color: currThis.colordata[i], y: data[i].count })
            }
            let options4 = {
              chart: {
                type: 'column',
                options3d: {
                  enabled: true,
                  alpha: 10,
                  beta: 5,
                  depth: 100,
                },
              },
              tooltip: {
                // head + 每个 point + footer 拼接成完整的 table
                headerFormat: '<table>',
                pointFormat:
                  '<tr>' +
                  '<td style="padding:0"><b>{point.y}篇 </b></td></tr>',
                footerFormat: '</table>',
                shared: true,
                useHTML: true,
              },
              xAxis: {
                type: 'category',
                categories: xdata,
                labels: {
                  format: '{value}',
                  rotation: -40, //倾斜的角度
                },
              },
              yAxis: {
                title: {
                  enabled: false,
                },
              },
              title: {
                text: '统计图4：本院历年PubMed论文期刊Top10',
                style: currThis.titleStyle,
              },
              plotOptions: {
                column: {
                  depth: 25,
                },
              },
              legend: {
                enabled: false,
                //backgroundColor: ((Highcharts.theme && Highcharts.theme.legendBackgroundColor) || '#FFFFFF'),
                shadow: true,
              },
              series: [
                {
                  data: ydata,
                },
              ],
              lang: currThis.lang,
              credits: {
                enabled: false,
              },
            }
            currThis.options4 = options4
            HighCharts.chart(currThis.id4, currThis.options4)
          } else if (index === 5) {
            if (data.IFPercent) currThis.recentif.percent = data.IFPercent
            data = data.resultList
            var xdata = []
            var ydata = []
            var zero = 0
            var all = 0
            const arr = ['0-1', '7-10', '10-15', '15-20', '20-X']
            for (var i = 0; i < data.length; i++) {
              xdata.push(data[i].recentIF)
              ydata.push(data[i].count)
              all += data[i].count
              if (arr.indexOf(data[i].recentIF.replace(/\s*/g, '')) == -1) {
                zero += data[i].count
              }
            }
            let options5 = {
              chart: {
                type: 'column',
              },
              title: {
                text: '统计图5：本院历年PubMed论文SCI影响因子',
                style: currThis.titleStyle,
              },
              xAxis: {
                categories: xdata,
                crosshair: true,
              },
              yAxis: {
                min: 0,
                title: {
                  text: 'PubMed论文SCI影响因子记录数',
                },
                allowDecimals: false,
              },
              tooltip: {
                // head + 每个 point + footer 拼接成完整的 table
                headerFormat: '<table>',
                pointFormat:
                  '<tr>' +
                  '<td style="padding:0"><b>{point.y}篇 </b></td></tr>',
                footerFormat: '</table>',
                shared: true,
                useHTML: true,
              },
              plotOptions: {
                column: {
                  borderWidth: 0,
                },
              },
              legend: {
                enabled: false,
                //backgroundColor: ((Highcharts.theme && Highcharts.theme.legendBackgroundColor) || '#FFFFFF'),
                shadow: true,
              },
              series: [
                {
                  data: ydata,
                },
              ],
              lang: currThis.lang,
              credits: {
                enabled: false,
              },
            }
            currThis.options5 = options5
            HighCharts.chart(currThis.id5, currThis.options5)
            if (all != 0) {
              currThis.recentif.percent = ((zero / all) * 100).toFixed(2)
            }
            if (data.length > 0) {
              currThis.recentif.records = data
            }
          } else if (index === 6) {
            var newdata = []
            data.resultList.forEach(function (item) {
              newdata.push([item.jcrPartition, Number(item.ratio) * 100])
            })
            let options6 = {
              chart: {
                type: 'pie',
                options3d: {
                  enabled: true,
                  alpha: 45,
                  beta: 0,
                },
              },
              title: {
                text: '统计图6：本院历年PubMed论文期刊分区TOP10',
                style: currThis.titleStyle,
              },
              tooltip: {
                pointFormat: '<b>{point.percentage:.1f}%</b>',
              },
              plotOptions: {
                pie: {
                  allowPointSelect: true,
                  cursor: 'pointer',
                  depth: 35,
                  dataLabels: {
                    enabled: true,
                    format: '{point.name}',
                  },
                },
              },
              series: [
                {
                  type: 'pie',
                  name: '占比',
                  data: newdata,
                },
              ],
              lang: currThis.lang,
              credits: {
                enabled: false,
              },
            }

            currThis.options6 = options6
            HighCharts.chart(currThis.id6, currThis.options6)
          } else if (index === 7) {
            var newdata = []
            data.resultList.forEach(function (item) {
              newdata.push({ name: item.zkyPartition, data: [item.count] })
              currThis.zkypart.push(item.zkyPartition)
            })
            let options7 = {
              chart: {
                type: 'bar',
              },
              title: {
                text: '统计图7：本院PubMed论文本院期刊分区分析',
                style: currThis.titleStyle,
              },
              xAxis: {
                categories: [''],
                title: {
                  text: null,
                },
                minTickInterval: 1,
              },
              yAxis: {
                min: 0,
                title: {
                  text: '论文数量 (篇)',
                  align: 'high',
                },
                allowDecimals: false,
              },
              tooltip: {
                valueSuffix: ' 篇',
              },
              plotOptions: {
                bar: {
                  dataLabels: {
                    enabled: true,
                    allowOverlap: true, // 允许数据标签重叠
                  },
                },
              },
              legend: {
                layout: 'vertical',
                align: 'right',
                verticalAlign: 'top',
                x: -10,
                y: 100,
                floating: true,
                borderWidth: 1,
                //backgroundColor: ((Highcharts.theme && Highcharts.theme.legendBackgroundColor) || '#FFFFFF'),
                shadow: true,
              },
              series: newdata,
              lang: currThis.lang,
              credits: {
                enabled: false,
              },
            }
            currThis.options7 = options7
            HighCharts.chart(currThis.id7, currThis.options7)
          } else if (index === 8) {
            var xdata = []
            var ydata = []
            var all = 0
            data.resultList.forEach(function (item) {
              xdata.push(item.name)
              ydata.push(item.count)
              all = all + item.count
            })
            let options8 = {
              chart: {
                type: 'column',
              },
              title: {
                text: '统计图8：本院PubMed论文第一作者机构',

                style: currThis.titleStyle,
              },
              xAxis: {
                categories: xdata,
                crosshair: true,
              },
              yAxis: {
                min: 0,
                title: {
                  text: '第一作者机构记录数',
                },
                allowDecimals: false,
              },
              tooltip: {
                // head + 每个 point + footer 拼接成完整的 table
                headerFormat: '<table>',
                pointFormat:
                  '' + '<td style="padding:0"><b>{point.y}</b>篇</td></tr>',
                footerFormat: '</table>',
                shared: true,
                useHTML: true,
              },
              plotOptions: {
                column: {
                  borderWidth: 0,
                },
              },
              legend: {
                enabled: false,
                //backgroundColor: ((Highcharts.theme && Highcharts.theme.legendBackgroundColor) || '#FFFFFF'),
                shadow: true,
              },
              series: [
                {
                  data: ydata,
                },
              ],
              lang: currThis.lang,
              credits: {
                enabled: false,
              },
            }

            currThis.options8 = options8
            HighCharts.chart(currThis.id8, currThis.options8)
            currThis.hos = data.resultList[0]
            axios({
              method: 'get',
              url: '/api/analysis',
            })
              .then(function (response) {
                currThis.analysis = response.data.data
                currThis.hos.percent = (
                  (currThis.hos.count / currThis.analysis.foreginNum) *
                  100
                ).toFixed(2)
              })
              .catch(function (thrown) {})
          } else if (index === 9) {
            var wordclouddata = []
            data.resultList.forEach(function (item) {
              wordclouddata.push({ name: item.keyword, weight: item.count })
            })
            let options9 = {
              tooltip: {
                pointFormat: '<b>{point.weight}次</b>',
                shared: true,
                useHTML: true,
              },
              series: [
                {
                  type: 'wordcloud',
                  data: wordclouddata,
                },
              ],
              title: {
                text: '',
              },
              lang: currThis.lang,
              credits: {
                enabled: false,
              },
            }
            currThis.options9 = options9
            HighCharts.chart(currThis.id9, currThis.options9)
          }
        })
        .catch(function (thrown) {})
    },
  },
  mounted() {
    this.getData(1)
    this.getData(2)
    this.getData(3)
    this.getData(4)
    this.getData(5)
    this.getData(6)
    this.getData(7)
    this.getData(8)
    this.getData(9)
  },
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/analysis.vue